export const validateClientOrgDetails = (data = {}) => {
  const {
    kycDocuments = [],
    addresses = [],
    emails = [],
    contactNumbers = [],
    businessDetail = {},
  } = data;

  const gst = kycDocuments.find((doc) => doc.idType === "GST")?.idNumber;
  const defaultAddress = addresses.find(
    (addr) => addr.type?.toUpperCase() === "DEFAULT"
  );
  const email = emails.find((e) => e.type?.toLowerCase() === "default")?.email;
  const mobileNum = contactNumbers.find(
    (c) => c.type?.toLowerCase() === "default"
  )?.number;
  const { businessName, natureOfBusiness } = businessDetail;

  // return true if any required field is missing
  return [
    gst,
    defaultAddress?.street,
    defaultAddress?.pincode,
    businessName,
    natureOfBusiness,
    email,
    mobileNum,
  ].some((field) => !field);
};

export const validateBusinessDetails = (data = {}) => {
  const { contacts = [], addresses = [], businessDetail = {} } = data;
  const officeAddress = addresses.find(
    (addr) => addr.type?.toLowerCase() === "office"
  );
  const billingAddress = addresses.find(
    (addr) => addr.type?.toLowerCase() === "billing"
  );

  return [
    contacts?.[0]?.departmentName,
    contacts?.[0]?.designation,
    officeAddress?.street,
    officeAddress?.pincode,
    billingAddress?.street,
    billingAddress?.pincode,
    businessDetail?.businessName,
    businessDetail?.natureOfBusiness,
    businessDetail?.pickUpTime,
    businessDetail?.turnOver,
  ].some((field) => !field);
};
